import { DirectionsBoat } from '@mui/icons-material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { M_DrawerTableTextField, M_Fieldset, M_FormFavorites, M_InputTextField, M_Select } from 'src/M_Components'

const changes = (field, value, setData) => {
    setData(prev => ({ ...prev, [field]: value }))
}

const boundOptions = [
    { value: 'E', label: 'Export' },
    { value: 'I', label: 'Import' },
    { value: 'T', label: 'Transit' },
    { value: 'N', label: 'Internal' },
    { value: 'P', label: 'Operations' },
    { value: 'O', label: 'Other' },
]

const tradeTypeOptions = [
    { value: '0', label: 'Vessel' },
    { value: '1', label: 'Period' },
]

export const TradeInfo = ({ dataState, setDataState, isView = false }) => {
    const { t } = useTranslation()

    const tradeVarNameDict = useMemo(() => new Map([
        ['LineCode',  dataState?.LineCode  || ''],
        ['AccountId', dataState?.AccountId || ''],
    ]), [dataState?.LineCode, dataState?.AccountId])

    return (
    <M_FormFavorites
        entityName="Trade"
        pageUrl="Trade"
        varNameDict={tradeVarNameDict}
        setVarNameDict={() => {}}
        onFavoriteLoad={(loadedData) => {
            setDataState(prev => ({ ...prev, ...loadedData }))
        }}
        onAfterApply={() => {}}
    >
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                    <DirectionsBoat style={{ marginRight: '10px', scale: '1.3' }} />
                    {t('TradeDetails')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                    <div style={{ margin: '5px' }}>
                        <M_DrawerTableTextField
                            size="250px"
                            label={t('LineCode')}
                            tableLabel="Account"
                            entity="Account"
                            filterField="AccountCode"
                            labelFields={['AccountCode']}
                            required={!isView}
                            disabled={isView}
                            color={!isView && !dataState?.TradeLineName ? 'var(--color-red)' : undefined}
                            secondColor={!isView && !dataState?.TradeLineName ? 'var(--color-red)' : undefined}
                            value={dataState?.AccountId
                                ? { Id: dataState.AccountId, AccountCode: dataState.LineCode, AccountName: dataState.TradeLineName }
                                : null
                            }
                            onSubmitValue={(obj) => {
                                if (isView) return
                                setDataState(prev => ({
                                    ...prev,
                                    AccountId: obj?.Id || '',
                                    TradeLineCode: obj?.AccountCode || '',
                                    LineCode: obj?.AccountCode || '',
                                    TradeLineName: obj?.AccountName || '',
                                }))
                            }}
                            favoritesFieldName={t('LineCode')}
                            favoritesGroupName="Trade"
                            favoritesVarKey="LineCode"
                            favoritesIdKey="AccountId"
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_InputTextField
                            size="250px"
                            disabled
                            label={t('TradeLineName')}
                            value={dataState?.TradeLineName || ''}
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_Select
                            label={t('TradeBound')}
                            value={dataState?.TradeBound ?? ''}
                            options={boundOptions}
                            required={!isView}
                            disabled={isView}
                            color={!isView && !dataState?.TradeBound ? 'var(--color-red)' : undefined}
                            secondColor={!isView && !dataState?.TradeBound ? 'var(--color-red)' : undefined}
                            onChange={(e) => changes('TradeBound', e.target.value, setDataState)}
                            minWidth="180px"
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_InputTextField
                            size="150px"
                            label={t('TradeCode')}
                            required={!isView}
                            disabled={isView}
                            color={!isView && !dataState?.TradeCode ? 'var(--color-red)' : undefined}
                            secondColor={!isView && !dataState?.TradeCode ? 'var(--color-red)' : undefined}
                            value={dataState?.TradeCode || ''}
                            onChange={(e) => changes('TradeCode', e.target.value, setDataState)}
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_InputTextField
                            size="250px"
                            label={t('TradeName')}
                            required={!isView}
                            disabled={isView}
                            color={!isView && !dataState?.TradeName ? 'var(--color-red)' : undefined}
                            secondColor={!isView && !dataState?.TradeName ? 'var(--color-red)' : undefined}
                            value={dataState?.TradeName || ''}
                            onChange={(e) => changes('TradeName', e.target.value, setDataState)}
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_Select
                            label={t('TradeType')}
                            value={dataState?.TradeType ?? ''}
                            options={tradeTypeOptions}
                            required={!isView}
                            disabled={isView}
                            hasNone={!isView}
                            color={!isView && !dataState?.TradeType ? 'var(--color-red)' : undefined}
                            secondColor={!isView && !dataState?.TradeType ? 'var(--color-red)' : undefined}
                            onChange={(e) => changes('TradeType', e.target.value, setDataState)}
                            minWidth="180px"
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_InputTextField
                            size="250px"
                            label={t('TradeAccountingCodeA')}
                            disabled={isView}
                            value={dataState?.TradeAccountingCodeA || ''}
                            onChange={(e) => changes('TradeAccountingCodeA', e.target.value, setDataState)}
                        />
                    </div>
                    <div style={{ margin: '5px' }}>
                        <M_InputTextField
                            size="250px"
                            label={t('TradeAccountingCodeB')}
                            disabled={isView}
                            value={dataState?.TradeAccountingCodeB || ''}
                            onChange={(e) => changes('TradeAccountingCodeB', e.target.value, setDataState)}
                        />
                    </div>
                </div>
            }
        />
    </M_FormFavorites>
    )
}
